import React, { useEffect } from "react";
import "../graphStyles.scss";
import { ExportCSVButton } from "../../ExportCSVButton";
import NoDataFound from "../../NoDataFound";
import DateRangeFilter from "../DateRangeFilter/DateRangeFilter";
import useDateRangeFilter from "../DateRangeFilter/useDateRangeFilter";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);

export function UniqueVisitorsAddedToCartGraph({
  weeks,
  percentOfVisitors,
  visitors,
  graphLabel,
}) {
  const { filteredWeeks, filteredData, onFilterChange } = useDateRangeFilter({
    weeks,
    dataArrays: { percentOfVisitors, visitors },
  });
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Maintain aspect ratio to ensure responsiveness
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: function () {
              if (window.innerWidth < 830 && window.innerWidth > 570) {
                return 9;
              } else {
                return 13;
              }
            },
          },
        },
        onHover: function (event, legendItem) {
          document.getElementById("chart3").style.cursor = "pointer";
        },
        onLeave: function (event, legendItem) {
          document.getElementById("chart3").style.cursor = "default";
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Week",
          font: {
            size: function () {
              if (window.innerWidth < 830 && window.innerWidth > 570) {
                return 9;
              } else {
                return 13;
              }
            },
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: function () {
              if (window.innerWidth < 830 && window.innerWidth > 570) {
                return 9;
              } else {
                return 13;
              }
            },
          },
        },
      },
      y: {
        type: "linear",
        position: "left",
        title: {
          display: true,
          text: "Number of visitors",
          font: {
            size: function () {
              if (window.innerWidth < 830 && window.innerWidth > 570) {
                return 9;
              } else {
                return 13;
              }
            },
          },
        },
        ticks: {
          font: {
            size: function () {
              if (window.innerWidth < 830 && window.innerWidth > 570) {
                return 9;
              } else {
                return 13;
              }
            },
          },
        },
      },
      y1: {
        type: "linear",
        position: "right",
        min: 0,
        title: {
          display: true,
          text: "% of total visitors",
          font: {
            size: function () {
              if (window.innerWidth < 830 && window.innerWidth > 570) {
                return 9;
              } else {
                return 13;
              }
            },
          },
        },
        ticks: {
          font: {
            size: function () {
              if (window.innerWidth < 830 && window.innerWidth > 570) {
                return 9;
              } else {
                return 13;
              }
            },
          },
        },
      },
    },
  };

  const labels = filteredWeeks;

  const data = {
    labels,
    datasets: [
      {
        label: "% of total visitors",
        data: filteredData.percentOfVisitors,
        yAxisID: "y1",
        type: "line",
        borderWidth: 3,
        borderColor: "rgba(0, 80, 248, 0.83)",
        backgroundColor: "rgba(0, 80, 248, 0.83)",
        hoverBackgroundColor: "rgba(0, 80, 248, 0.83)",
        pointRadius: function () {
          if (window.innerWidth < 990 && window.innerWidth > 700) {
            return 2.5;
          }
          return 1.5;
        },
      },
      {
        label: "Number of visitors",
        data: filteredData.visitors,
        backgroundColor: "rgba(250, 210, 90, 0.99)",
        hoverBackgroundColor: "rgba(250, 210, 90, 0.99)",
        yAxisID: "y",
      },
    ],
  };

  const allData = [
    ["Number of visitors", ...filteredData.visitors],
    ["% of Total Visitors", ...filteredData.percentOfVisitors],
  ];

  return (
    <div className="graph">
      <div className="graph__title flex flex-col md:flex-row justify-between items-center">
        <h4 className="text-lg md:text-xl font-semibold text-center md:text-left mb-2 md:mb-0">
          {graphLabel ?? "Unique visitors who added to cart"}
        </h4>
        <div className="flex items-center gap-2 flex-wrap justify-end pr-3">
          <DateRangeFilter weeks={weeks} onFilterChange={onFilterChange} />
          <ExportCSVButton
            allData={allData}
            name={"Unique_visitors_who_added_to_cart"}
            className="w-full md:w-auto"
          />
        </div>
      </div>
      {weeks?.length === 0 ? (
        <NoDataFound />
      ) : (
        <div className="relative w-full h-64 md:h-96">
          <Chart className="chart" id="chart3" type="bar" options={options} data={data} />
        </div>
      )}
    </div>
  );
}
